import { render, staticRenderFns } from "./AppScore.vue?vue&type=template&id=3b3081d1&"
import script from "./AppScore.vue?vue&type=script&lang=js&"
export * from "./AppScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports